module.exports = __webpack_public_path__ + "static/media/wangui.8256b468.jpg";